module.exports = __webpack_public_path__ + "media/images/icon_deadline-98a62c6710d869b04b087013ecfd9be2.png";